import { Injectable } from '@angular/core';
import { StoreInterface } from '../interfaces/store.interface';
import { CostCenterItemsStore } from './entities/cost-center-items/cost-center-items.store';
import { CostCenterItemsQuery } from './entities/cost-center-items/cost-center-items.query';
import {OrderItemsStore} from "./entities/order-items/order-items.store";
import {OrderItemsQuery} from "./entities/order-items/order-items.query";

@Injectable({ providedIn: 'root' })
export class CostCenterItemsStoreService {
  private stores = new Map();

  constructor() {}

  getOrCreateStore(name: string): StoreInterface<CostCenterItemsStore, CostCenterItemsQuery> {
    if (!name) {
      return;
    }
    if (this.stores.has(name)) {
      return this.getState(name);
    } else {
      const store = new CostCenterItemsStore(name);
      const query = new CostCenterItemsQuery(store);

      const state = { store, query };
      this.stores.set(name, state);
      return state;
    }
  }

  private getState(name: string) {
    return this.stores.get(name);
  }
}
